import React, { useState } from "react";
import { useHistory } from "react-router";
import { useAppDispatch, adminLogin, pushNotification } from "../store";
import "./AdminLogin.scss";
import Heading from "./partials/Heading";

interface Props {}

function AdminLogin(props: Props) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useAppDispatch();
  const history = useHistory();

  return (
    <div className="admin-login-page">
      <Heading>ADMIN LOGIN</Heading>
      <form className="login-form">
        <label htmlFor="username">
          username
          <input
            id="username"
            value={username}
            onChange={(ev) => setUsername(ev.target.value)}
            name="username"
            required
            type="text"
            minLength={8}
          />
        </label>
        <label htmlFor="password">
          password
          <input
            id="password"
            value={password}
            onChange={(ev) => setPassword(ev.target.value)}
            name="password"
            required
            type="password"
            minLength={8}
          />
        </label>
        <div className="button-group">
          <button
            className="positive"
            onClick={(ev) => {
              // console.log(username, password);
              if (username.length >= 8) {
                if (password.length >= 8) {
                  dispatch(adminLogin({ username, password }));
                } else {
                  dispatch(
                    pushNotification({
                      type: "error",
                      text: "Password must be 8 characters or more.",
                    })
                  );
                }
              } else {
                dispatch(
                  pushNotification({
                    type: "error",
                    text: "Username must be 8 characters or more.",
                  })
                );
              }
              ev.preventDefault();
            }}
          >
            login
          </button>
          <button
            className="neutral"
            onClick={(ev) => {
              // console.log(username, password);
              history.push("/admin/register");
              ev.preventDefault();
            }}
          >
            create account
          </button>
        </div>
      </form>
    </div>
  );
}
export { AdminLogin as default };
